import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export function useRedirectAfterLogin() {
    const location = useLocation();
    const navigate = useNavigate();
    React.useEffect(() => {
        const redirectUrl = window.sessionStorage.getItem('redirectUrl');
        if (redirectUrl != null) {
            window.sessionStorage.removeItem('redirectUrl');
            if (location.pathname !== redirectUrl) {
                navigate(redirectUrl);
            }
        }
        // deps param is intentionally empty, because we want this code to run only once
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
